// extracted by mini-css-extract-plugin
module.exports = {"container":"NotesListViewer_container__2Ue2h","header":"NotesListViewer_header__1g-UV","spin-container":"NotesListViewer_spin-container__2i2gf"};